module.exports = __webpack_public_path__ + "img/icon_assembleN.835ef39b.svg";